// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"d1a84701","96":"a345c759","152":"7895ee55","741":"87f5a2a3","873":"2e388944","947":"0c6a57a8"}[chunkId] + ".chunk.js";
};